<template>
    <div class="resource-appoitment-card multiple-orders-card" :id="`multiple-resource-card-${resource.resourceId}`"
        :style="`background-color:${resource.status.color}`" @click="handleClick">

        <div class="card__header">
            <div class="code">{{ resource.resourceName }}</div>
            <div class="appointment-type">{{ appointmentTypeLabel }}</div>
            <div class="info-row" :style="`color:${resource.status.color}`">
                <div class="status" :style="`border-color:${resource.status.color}`">
                    {{ $t(resource.status.name) }}
                </div>
                <div class="duration" :style="`border-color:${resource.status.color}`">
                    <span class="icon">
                        <TimeIcon :style="`fill:${resource.status.color}`" />
                    </span>
                    <ResourceDuration :resource="resource" />
                </div>
            </div>
        </div>

        <div class="card__body">
            <div class="orders-count">
                <div class="orders-count__value">
                    {{ orders.length }}
                </div>
                <div class="orders-count__label">
                    {{ $t("MultipleOrders.AvailableOrders") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResourceDuration from "@/views/pages/operator/components/Resources/ResourceDuration.vue";

export default {
    props: {
        resource: {
            type: Object,
            default: () => ({
                resourceId: null,
                resourceName: "",
                appointmentType: null,
                durationInHours: 0,
                status: {
                    statusId: null,
                    name: "",
                    color: ""
                }
            })
        },
        orders: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        appointmentTypeLabel() {
            return this.resource.appointmentType === 1
                ? this.$t("ManualAppointment")
                : this.$t("AutomaticAppointment");
        },
        isExtrusionFlow() {
            return !!(
                this.resource &&
                (this.resource.isExtrusionFlow === true ||
                    this.resource.isExtrusionFlow === 1 ||
                    this.resource.IsExtrusionFlow === true)
            );
        }
    },
    methods: {
        handleClick() {
            if (this.isExtrusionFlow) {
                this.$bvToast?.toast(
                    "Recurso de Extrusão: Apontamento disponível exclusivamente no menu Extrusão e Fornos.",
                    {
                        title: "Fluxo de Extrusão",
                        variant: "warning",
                        solid: true
                    }
                );
                return;
            }
            if (this.orders.length === 0) return;

            this.$emit("selectCard", { resource: this.resource, orders: this.orders });
        }
    },
    components: {
        ResourceDuration,
        TimeIcon: () => import("@core/assets/icons/time-icon.svg")
    }
};
</script>

<style lang="scss">
.resource-appoitment-card.multiple-orders-card {
    position: relative;
    min-height: 280px;
    height: auto;
    border-radius: 16px;
    overflow: hidden;
    color: #fff;
    font-family: sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    cursor: pointer;
    transition: transform 0.2s ease;
    min-width: 375px;
    max-width: 375px;

    .card__header {
        text-align: center;

        .code {
            padding: 16px;
            color: #fff;
            text-align: center;
            font-size: 26px;
            font-weight: 600;
            line-height: 36px;
        }

        .appointment-type {
            color: #fff;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            padding: 0 16px 8px;
        }

        .info-row {
            display: flex;
            font-size: 22px;
            font-weight: 600;
            line-height: 30px;
            background: #fff;

            .status,
            .duration {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                width: 100%;
                text-align: center;
                border: 1px solid;
            }

            .duration {
                max-width: 160px;
                white-space: nowrap;
            }

            .status {
                padding: 16px 0;
                border-right: none;
            }

            .icon {
                svg {
                    display: flex;
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }

    .card__body {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px 16px;

        .orders-count {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;

            &__value {
                color: #fff;
                text-align: center;
                font-size: 48px;
                font-weight: 700;
                line-height: 56px;
            }

            &__label {
                color: #fff;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
            }
        }
    }
}

@media (max-width: 480px) {
    .resource-appoitment-card.multiple-orders-card {
        .card__header {
            .code {
                padding: 8px 16px;
                font-size: 18px;
                line-height: 26px;
            }

            .info-row {
                font-size: 16px;
                line-height: 26px;

                .status {
                    padding: 8px 0;
                }
            }
        }
    }
}
</style>
